<template>
  <div>
    <div class="parent">
      <v-card>
        <v-card-title class="info-title" @click="$emit('clicked', index)">
          <font-awesome-icon
            class="collapse"
            :icon="selected ? 'angle-down' : 'angle-left'"
          />
          <div class="text-center text-padding">
            {{ item.StrState }}
          </div>
        </v-card-title>
        <div>
          <app-row
            icon="hashtag"
            title="شناسه درخواست:"
            :value="item.Fserial"
          />
          <app-row
            icon="calendar-alt"
            title="تاریخ درخواست:"
            :value="item.DDate"
          />
          <div style="padding: 15px">
            <v-row align="center">
              <v-col class="d-flex">
                <b>نظر واحد حراست:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                {{ item.TahghighatState }}.
                <span v-html="item.TahghighatComment"></span>
              </v-col>
            </v-row>
            <template v-if="item.ShowMessage">
              <v-row align="center">
                <v-col class="d-flex">
                  <b>>شرکت در کارگاه تلبس:</b>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="content">
                 جهت شركت در كارگاه تلبس در مدرسه تبليغ، به آدرس زير مراجعه فرماييد:
                  <br />
                  <br />
                  <a href="https://tabliqkh.lms2.hozehkh.com/products/?categories=1731" target="_blank">
                    <img
                      :src="require(`../../assets/talabbos_icon.png`)"
                      style="width: 24px"
                      alt="ایتا"
                    />
                   سامانه مجازي مبلغان، مدرسه تبليغ
                  </a>

                  <br />
                  <br />
                  در صورت هرگونه سوال با شماره 05132008690  تماس حاصل
                  فرماييد.
                  <br />
                  <br />
                  با تشکر
                </v-col>
              </v-row>
            </template>
            <v-row align="center">
              <v-col class="d-flex">
                <b>شرکت در کارگاه:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                {{ item.TabliqState }}.
                <span v-html="item.TabliqComment"></span>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex">
                <b>نظر مدير محترم مدرسه يا استاد سطح دو:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                {{ item.TabliqState2 }}.
                <span v-html="item.TabliqComment2"></span>
              </v-col>
            </v-row>
            <v-row v-if="item.Removeable" class="ltr">
              <v-btn
                color="red white--text"
                class="register"
                rounded
                @click="$emit('removeRequest', item.Fserial)"
              >
                حذف درخواست
              </v-btn>
            </v-row>
            <v-row v-else-if="item.State == 1" class="ltr">
              <v-btn
                color="red white--text"
                class="register"
                rounded
                @click="$emit('callDownload', item.Fserial)"
              >
                دانلود گواهی تلبس
              </v-btn>
            </v-row>
            <div style="padding: 5px"></div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["item", "index", "selectedItem"],
  computed: {
    selected() {
      return this.selectedItem == this.index;
    },
    dateRange() {
      return "از " + this.item.AzTarikh + " تا " + this.item.TaTarikh;
    },
  },
  components: {
    appRow: DetailRow,
  },
};
</script>
<style scoped>
.register {
  margin: 20px 20px 0 20px !important;
}
</style>
